import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Box, Text as BaseText, Flex as BaseFlex, ButtonOutlined } from '../../../Base';

const Flex = styled(BaseFlex)`
  border-radius: 12px;
`;

const Text = (props) => (
  <BaseText fontWeight="medium" fontFamily="content" color="articleDetails" {...props} />
);

const CourseDownloadableMaterials = ({ t, items, onDownloadClick, ...props }) => {
  const renderMaterialsItems = () => {
    if (!(Array.isArray(items) && items.length)) return null;
    return items.map((material, index) => (
      <Flex
        key={`material-${material.id}-${index}`}
        px={[3, null, 5, 7]}
        py={[2, null, 4]}
        mb={index !== items.length - 1 ? 2 : 0}
        justifyContent={['center', null, 'space-between']}
        alignItems="center"
        bg="downloadableItemsBackground"
        flexDirection={['column', null, 'row']}
      >
        <Text mb={[3, null, 0]}>{material.title}</Text>
        <ButtonOutlined
          borderRadius="100px"
          px="20px"
          py={2}
          onClick={() => onDownloadClick(material?.content?.data?.key ?? '#', material?.referId)}
        >
          <Text fontSize={1} color="inherit">
            {t('COURSE_DOWNLOADABLE_MATERIALS.DOWNLOAD')}
          </Text>
        </ButtonOutlined>
      </Flex>
    ));
  };

  return (
    <Box {...props}>
      <Text mb={6} fontSize={4}>
        {t('COURSE_DOWNLOADABLE_MATERIALS.HEADER')}
      </Text>
      {renderMaterialsItems()}
    </Box>
  );
};

CourseDownloadableMaterials.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onDownloadClick: PropTypes.func,
  downloadUrl: PropTypes.string,
};

CourseDownloadableMaterials.defaultProps = {
  items: [],
  onDownloadClick: () => {},
  downloadUrl: '#',
};

export default withTranslation('classroom')(CourseDownloadableMaterials);
